module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/tags-c3053808ef0deba0f39935e055ed9f43.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/tags.svg
// module id = 4nMc
// module chunks = 24